import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export function PageNotFound() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        minHeight: '100vh',
        px: 2
      }}
    >
      <Typography variant="h1">
        404
      </Typography>
      <Typography variant="h6" sx={{textAlign: 'center'}}>
        The page you’re looking for doesn’t exist.
      </Typography>
      <Button variant="contained" href='/' sx={{mt: 2}}>Back Home</Button>
    </Box>
  );
}